<template>
    <div style="width: 100%; height: 100%">
        <content-loader v-if="loading" style="width: 100%; height: 100%" />
        <apexchart
            v-if="!loading && isMounted"
            :options="{
                ...options,
                colors,
                xaxis: { ...options.xaxis, categories },
            }"
            :series="seriesData"
            height="100%"
            type="bar"
            width="90%"
            @data-point-selection="onChartClick"
        >
        </apexchart>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ContentLoader } from 'vue-content-loader';

export interface DataItem {
    name: string;
    data: number[];
}

export default defineComponent({
    components: {
        ContentLoader,
    },
    data: function () {
        return {
            isMounted: false,
            options: {
                legend: {
                    show: this.showLegend,
                    position: 'left',
                    fontFamily: 'Roboto, sans-serif',
                },
                chart: {
                    id: 'vuechart-example',
                    type: 'bar',
                    stacked: true,
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                },
                xaxis: {
                    tickPlacement: 'on',
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        format: 'MMMM. yy',
                    },
                },
                yaxis: {
                    axisBorder: {
                        show: true,
                    },
                },
                tooltip: {
                    followCursor: false,
                    intersect: false,
                    custom: this.customTooltip,
                },
                states: {
                    active: {
                        allowMultipleDataPointsSelection: false,
                    },
                    hover: {
                        filter: {
                            type: 'opacity',
                            value: 0.8,
                        },
                    },
                },
            },
        };
    },
    props: {
        seriesData: { type: Array as PropType<DataItem[]>, required: true },
        categories: { type: Array as PropType<string[]>, required: true },
        yDescription: String,
        colors: Array as PropType<string[]>,
        showLegend: { type: Boolean, required: true },
        loading: { type: Boolean, required: true },
        customTooltip: { type: Function, required: false },
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        onChartClick(_event: any, _chartContext: any, config: any) {
            this.$emit('dataPointClicked', { seriesIndex: config.seriesIndex, dataPointIndex: config.dataPointIndex });
        },
    },
});
</script>

<style></style>
